import { render } from "./PageNotFound.vue?vue&type=template&id=64f2625f&scoped=true"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"

import "./PageNotFound.vue?vue&type=style&index=0&id=64f2625f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f2625f"]])

export default __exports__